import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import moment from 'moment';
import { ILocalizationService } from '@nimbus-library/features/localization/services/i-localization.service';
import { DateFormat, Language } from '@nimbus-library/features/localization/models/enums/language.enum';
import { CookieService } from '@nimbus-library/features/shared/services/cookies/cookies.service';

@Injectable()
export class LocalizationService extends ILocalizationService {
  private readonly languageCookieKey: string = 'user_language';
  private readonly dateFormatCookieKey: string = 'user_dateFormat';

  public constructor(private readonly cookieService: CookieService) {
    super();
  }

  public loadUserLanguage(): Observable<Language> {
    return of(this.cookieService.getCookie(this.languageCookieKey) as Language);
  }
  public saveUserLanguage(language: Language): Observable<void> {
    return of(this.cookieService.setCookie(this.languageCookieKey, language, moment().add(1, 'year')));
  }

  public loadUserDateFormat(): Observable<DateFormat> {
    return of(
      (this.cookieService.getCookie(this.dateFormatCookieKey) as DateFormat) ||
        (this.cookieService.getCookie(this.languageCookieKey) as DateFormat),
    );
  }
  public saveUserDateFormat(dateFormat: DateFormat): Observable<void> {
    return of(this.cookieService.setCookie(this.dateFormatCookieKey, dateFormat, moment().add(1, 'year')));
  }
}
